import { render, staticRenderFns } from "./GiftResult.vue?vue&type=template&id=8b79bbf0&scoped=true&"
import script from "./GiftResult.vue?vue&type=script&lang=js&"
export * from "./GiftResult.vue?vue&type=script&lang=js&"
import style0 from "./GiftResult.vue?vue&type=style&index=0&id=8b79bbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b79bbf0",
  null
  
)

export default component.exports